export default "__VITE_ASSET__CEOgzn3q__"